import React from "react";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Inputs from "../components/Inputs";
import { toast } from "react-toastify";
import { PasswordInput } from "../components/Buttons";

const ForgetPasswrod = () => {
  const handleSubmit = () => {
    toast.success("Password Reset Successfully");
  };
  return (
    <>
      {/* <Topbar/> */}

      <Navbar />

      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <div className="bg-white p-8 rounded-xl shadow-lg w-full max-w-md">
          {/* Title */}
          <h2 className="text-2xl font-bold text-center mb-6">
            Forget Password
          </h2>

          <form onSubmit={handleSubmit} className="space-y-4">
            <PasswordInput
              label="New Password"
              name="password"
              placeholder="Enter your new password"
            />
            <PasswordInput
              label="Confirm New Password"
              name="confirm_password"
              placeholder="Confirm your new password"
            />
            <button
              type="submit"
              className="w-full bg-black text-white py-3 rounded-lg hover:bg-gray-800 transition"
            >
              Reset Password
            </button>
          </form>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ForgetPasswrod;
